import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=44990daa&scoped=true&"
import script from "./Score.vue?vue&type=script&lang=js&"
export * from "./Score.vue?vue&type=script&lang=js&"
import style0 from "./Score.vue?vue&type=style&index=0&id=44990daa&lang=scss&scoped=true&"
import style1 from "./Score.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44990daa",
  null
  
)

component.options.__file = "Score.vue"
export default component.exports